import { lazyRoute, preloadLazyRoute } from "utils/lazyRoute";

const presentImport = () => import("views/Present");

export const LazyPresent = lazyRoute(presentImport);
LazyPresent.displayName = "Present";

export const preloadPresent = () => preloadLazyRoute(presentImport);
